import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-buytolet',
  templateUrl: './buytolet.component.html',
  styleUrls: ['./buytolet.component.css']
})
export class BuytoletComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
